import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { getServicesQueryOptions, unitByIdQueryOptions } from '@/service/vpc/queryOptions';

export const loaderUnitServicesPage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;
  const { fleetAccountId } = opts.context;

  if (!endCustomerUnitId || !fleetAccountId) {
    return;
  }

  // First fetch the unit data
  const unitData = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  const serviceData = await opts.context.queryClient.ensureQueryData(
    getServicesQueryOptions({ endCustomerUnitId, fleetAccountId })
  );

  return { unitData, serviceData, endCustomerUnitId, fleetAccountId };
};
